import { render } from "./myMall.vue?vue&type=template&id=70ad6e64&scoped=true"
import script from "./myMall.vue?vue&type=script&lang=js"
export * from "./myMall.vue?vue&type=script&lang=js"

import "./myMall.vue?vue&type=style&index=0&id=70ad6e64&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70ad6e64"]])

export default __exports__